"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common');
var ɵngcc2 = require('./owl-child.component');

var _c0 = ["owl"];
function OwlCarousel_owl_carousel_child_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "owl-carousel-child", 1, 2);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.carouselClasses)("options", ctx_r0.options);
} }
var _c1 = ["*"];
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var owl_child_component_1 = require("./owl-child.component");
var OwlCarousel = (function () {
    function OwlCarousel(differs) {
        this.differs = differs;
        this.carouselClasses = "";
        this.options = {};
        this.show = true;
    }
    Object.defineProperty(OwlCarousel.prototype, "items", {
        set: function (coll) {
            this._items = coll;
            if (coll && !this.differ) {
                this.differ = this.differs.find(coll).create(null);
            }
        },
        enumerable: true,
        configurable: true
    });
    OwlCarousel.prototype.ngDoCheck = function () {
        if (this.differ) {
            var changes = this.differ.diff(this._items);
            if (changes) {
                var changed = false;
                var changedFn = function () {
                    changed = true;
                };
                changes.forEachAddedItem(changedFn);
                changes.forEachMovedItem(changedFn);
                changes.forEachRemovedItem(changedFn);
                if (changed) {
                    this.refresh();
                }
            }
        }
    };
    OwlCarousel.prototype.refresh = function () {
        var _this = this;
        this.show = false;
        setTimeout(function () {
            _this.show = true;
        }, 0);
    };
    OwlCarousel.prototype.next = function (options) {
        this.trigger('next.owl.carousel', options);
    };
    OwlCarousel.prototype.previous = function (options) {
        this.trigger('prev.owl.carousel', options);
    };
    OwlCarousel.prototype.to = function (options) {
        this.trigger('to.owl.carousel', options);
    };
    OwlCarousel.prototype.trigger = function (action, options) {
        this.$owlChild.trigger(action, options);
    };
    __decorate([
        core_1.ViewChild('owl'), 
        __metadata('design:type', owl_child_component_1.OwlChild)
    ], OwlCarousel.prototype, "$owlChild", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], OwlCarousel.prototype, "carouselClasses", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], OwlCarousel.prototype, "options", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array), 
        __metadata('design:paramtypes', [Array])
    ], OwlCarousel.prototype, "items", null);
    OwlCarousel = __decorate([ __metadata('design:paramtypes', [core_1.IterableDiffers])
    ], OwlCarousel);
OwlCarousel.ɵfac = function OwlCarousel_Factory(t) { return new (t || OwlCarousel)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.IterableDiffers)); };
OwlCarousel.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwlCarousel, selectors: [["owl-carousel"]], viewQuery: function OwlCarousel_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.$owlChild = _t.first);
    } }, inputs: { carouselClasses: "carouselClasses", options: "options", items: "items" }, ngContentSelectors: _c1, decls: 1, vars: 1, consts: [[3, "ngClass", "options", 4, "ngIf"], [3, "ngClass", "options"], ["owl", ""]], template: function OwlCarousel_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, OwlCarousel_owl_carousel_child_0_Template, 3, 2, "owl-carousel-child", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.show);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.OwlChild, ɵngcc1.NgClass], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwlCarousel, [{
        type: core_1.Component,
        args: [{
                selector: 'owl-carousel',
                template: '<owl-carousel-child *ngIf="show" #owl [ngClass]="carouselClasses" [options]="options">' +
                    '<ng-content></ng-content></owl-carousel-child>'
            }]
    }], function () { return [{ type: ɵngcc0.IterableDiffers }]; }, { carouselClasses: [{
            type: core_1.Input
        }], options: [{
            type: core_1.Input
        }], items: [{
            type: core_1.Input
        }], $owlChild: [{
            type: core_1.ViewChild,
            args: ['owl']
        }] }); })();
    return OwlCarousel;
}());
exports.OwlCarousel = OwlCarousel;

//# sourceMappingURL=owl-carousel.component.js.map